// @ts-nocheck
import { emptyGuid } from "@insite/client-framework/Common/StringHelpers";
import { CategoryContext } from "@insite/client-framework/Components/CategoryContext";

import { Category, GetCategoriesApiParameter } from "@insite/client-framework/Services/CategoryService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import {
    getCategoriesDataView,
    getSubCategoryIds,
} from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import loadCategories from "@insite/client-framework/Store/Data/Categories/Handlers/LoadCategories";
import useGetCatoriesByIds from "@store/Framework/Common/Hooks/useGetCategoriesByIds";
import usePageType from "@toolkit/Framework/Common/GoogleAnalytics/hooks/utilities/usePageType";
import { toToolkitApplicationState } from "@toolkit/Framework/Store/ApplicationState";
import { useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

const getCategoriesParameter: GetCategoriesApiParameter = {
    maxDepth: 2,
    includeStartCategory: false,
};

const useCategoryListCategories = () => {
    const categoryContext = useContext(CategoryContext);
    const pageType = usePageType();
    const isPromotionDetailsPage = pageType === "PromotionDetailPage";
    const dispatch = useDispatch();
    const categoryDataView = useSelector((state: ApplicationState) =>
        getCategoriesDataView(state, getCategoriesParameter),
    );
    useEffect(() => {
        if (!categoryDataView.isLoading && !categoryDataView.value && !isPromotionDetailsPage) {
            dispatch(loadCategories(getCategoriesParameter));
        }
    }, [dispatch, categoryDataView.isLoading, categoryDataView.value, isPromotionDetailsPage]);
    const topLevelCategoryIds = useSelector((state: ApplicationState) => getSubCategoryIds(state, emptyGuid));
    const categoryIdsToUse = categoryContext ? categoryContext.subCategoryIds : topLevelCategoryIds;
    const categories = useGetCatoriesByIds(categoryIdsToUse || []);
    const promotionCategories = useSelector(
        (state: ApplicationState) => toToolkitApplicationState(state).bunzl.pages.promotionTree.categories,
    );

    return isPromotionDetailsPage ? promotionCategories : categories;
};

export default useCategoryListCategories;
